import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-journal-workflow',
  templateUrl: './journal-workflow.component.html',
  styleUrls: ['./journal-workflow.component.scss']
})
export class JournalWorkflowComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<JournalWorkflowComponent>) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
